import CreateShippingForm from "./CreateShippingForm"
import ShippingPageLayout from "./ShippingPageLayout"

const CreateShippingPage = () => {
  return (
    <ShippingPageLayout>
      <CreateShippingForm />
    </ShippingPageLayout>
  )
}

export default CreateShippingPage